import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import InvoiceGochiHistoryTableHead from '../../components/molecules/InvoiceGochiHistoryTableHead';
import InvoiceGochiHistoryTableBody from '../../components/molecules/InvoiceGochiHistoryTableBody';
import ExPagination from '../../components/molecules/ExPagination';
import { sendLogin } from '../../auth/Auth';
import ProgressDialog from '../../components/molecules/ProgressDialog';

const styles = {
  scrollTable: {
    maxHeight: '60vh',
    overflowX: 'scroll',
    whiteSpace: 'nowrap',
    display: 'block',
    width: '100%'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(state => ({
    invoices: state.shops.listHistoryInvoice
      ? state.shops.listHistoryInvoice
      : [],
    totalCount: state.shops.listHistoryInvoice
      ? state.shops.listHistoryInvoice.totalCount
      : 0,
    count: state.shops.listHistoryInvoice
      ? state.shops.listHistoryInvoice.count
      : 0,
    offset: state.shops.listHistoryInvoice
      ? state.shops.listHistoryInvoice.offset
      : 0,
    limit: state.shops.listHistoryInvoice
      ? state.shops.listHistoryInvoice.limit
      : 100
  })),
  setPropTypes(propTypes),
  withState('loading', 'updateLoading', false),
  withState('rowsPerPage', 'setRowsPerPage', 100),
  withState('targetRowId', 'setTargetRowId', 0),
  withState('order', 'setOrder', 'asc'),
  withState('orderBy', 'setOrderBy', null),
  withState('openDelete', 'updateOpenDelete', false),
  withState('openProgress', 'updateOpenProgress', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('deleteMessage', 'setDeleteMessage', ''),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleChangeRowsPerPage: props => event => {
      props.setRowsPerPage(event.target.value);
    },
    handleRequestSort: props => property => {
      const isDesc = props.orderBy === property && props.order === 'desc';
      props.setOrder(isDesc ? 'asc' : 'desc');
      props.setOrderBy(property);
    }
  }),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(
  ({
    classes,
    page,
    selectedPage,
    handleChangePage,
    count,
    offset,
    rowsPerPage,
    setTargetRowId,
    order,
    orderBy,
    handleChangeRowsPerPage,
    handleRequestSort,
    loading,
    updateOpenProgress,
    openProgress,
    resultMessage,
    invoices
  }) => {
    const progressOkAction = () => {
      updateOpenProgress(false);
    };

    let totalInvoice = 0;
    if (invoices && invoices.list && invoices.list.length) {
      totalInvoice = invoices.list.length;
    }

    const emptyRows =
      rowsPerPage - Math.min(rowsPerPage, totalInvoice - page * rowsPerPage);

    return (
      <div>
        <div className={classes.scrollTable} id="scrollTableId">
          <Table stickyHeader>
            <InvoiceGochiHistoryTableHead
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
            />
            <InvoiceGochiHistoryTableBody
              invoices={invoices.list}
              emptyRows={emptyRows}
              page={page}
              rowsPerPage={rowsPerPage}
              order={order}
              orderBy={orderBy}
              setTargetRowId={setTargetRowId}
            />
          </Table>
        </div>
        <div>
          <ExPagination
            searchResults={invoices.list}
            rowsPerPage={rowsPerPage}
            page={page}
            handleChangePage={handleChangePage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            totalCount={count}
            offset={offset}
            selectedPage={selectedPage}
          />
        </div>
        <ProgressDialog
          openProgress={openProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={resultMessage}
        />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
